// PaymentMethodPanel.tsx
// Displays payment method card and billing email

import {
  useState,
  // useEffect
} from 'react';
import { VSpace } from '../../account/account-settings';
import { Title } from '../../account/account-settings.styled';
import { Panel } from '../../settings.styled';
import { ActionText } from '../../account/account-settings.styled';
import { MetaRow, Divider } from '../billing.styled';
import ChangeEmailModal from '../modals/change-email/change-email';
import { useSettingsContext } from '../../settings-context';
// import { useModalContext } from '../../modal-context';
import { billingDetailsApi } from '../../../../../api';
// import { paymentsApi } from '../../../../../api/payments/payments'; // Stripe disabled
// import type { StripePaymentMethod } from '../../../../../api/payments/payments.types'; // Stripe disabled

// ─────────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────────

// function formatBrand(brand: string): string {
//   const map: Record<string, string> = {
//     visa: 'Visa',
//     mastercard: 'Mastercard',
//     amex: 'Amex',
//     discover: 'Discover',
//     diners: 'Diners',
//     jcb: 'JCB',
//     unionpay: 'UnionPay',
//   };
//   return map[brand?.toLowerCase()] || brand || 'Card';
// }

// ─────────────────────────────────────────────────────────────────────────────
// Props
// ─────────────────────────────────────────────────────────────────────────────

interface PaymentMethodPanelProps {
  profileEmail?: string | undefined;
}

// ─────────────────────────────────────────────────────────────────────────────
// Component
// ─────────────────────────────────────────────────────────────────────────────

export function PaymentMethodPanel({ profileEmail }: PaymentMethodPanelProps) {
  const {
    billingDetails,
    //  planState, paymentInfo,
    updateBillingDetails,
  } = useSettingsContext();
  // const { openModal } = useModalContext();

  const [changeEmailOpen, setChangeEmailOpen] = useState(false);
  const [emailSaveError, setEmailSaveError] = useState<string | null>(null);
  // const [cardInfo, _setCardInfo] = useState<any | null>(null); // StripePaymentMethod — Stripe disabled
  // const [cardLoading, _setCardLoading] = useState(false);
  // const [cardError, _setCardError] = useState(false);

  // Determine if user has payment method on file based on Stripe customer
  // const hasStripeCustomer = !!paymentInfo?.stripe_customer_id;
  const displayEmail = billingDetails?.billingEmail || profileEmail || '';

  // useEffect(() => {
  //   if (!hasStripeCustomer) {
  //     setCardInfo(null);
  //     return;
  //   }
  //   let cancelled = false;
  //   setCardLoading(true);
  //   setCardError(false);
  //   paymentsApi
  //     .getPaymentMethods()
  //     .then(({ payment_methods }) => {
  //       if (!cancelled) {
  //         setCardInfo(payment_methods.length > 0 ? payment_methods[0] : null);
  //       }
  //     })
  //     .catch(() => {
  //       if (!cancelled) {
  //         setCardInfo(null);
  //         setCardError(true);
  //       }
  //     })
  //     .finally(() => {
  //       if (!cancelled) setCardLoading(false);
  //     });
  //   return () => { cancelled = true; };
  // }, [hasStripeCustomer]);

  const handleOpenChangeEmail = () => {
    setEmailSaveError(null);
    setChangeEmailOpen(true);
  };
  const handleCloseChangeEmail = () => setChangeEmailOpen(false);

  const handleSaveChangeEmail = async (payload: { email: string; currentPassword: string }) => {
    try {
      const updatedDetails = {
        firstName: billingDetails?.firstName || '',
        lastName: billingDetails?.lastName || '',
        companyName: billingDetails?.companyName || '',
        streetAddress: billingDetails?.streetAddress || '',
        city: billingDetails?.city || '',
        stateProvince: billingDetails?.stateProvince || '',
        postalCode: billingDetails?.postalCode || '',
        country: billingDetails?.country || '',
        vatTaxId: billingDetails?.vatTaxId || '',
        billingEmail: payload.email,
      };
      await billingDetailsApi.update(updatedDetails);
      updateBillingDetails(updatedDetails);
      setChangeEmailOpen(false);
    } catch (error) {
      console.error('Failed to update billing email:', error);
      setEmailSaveError('Failed to update billing email. Please try again.');
    }
  };

  // const handlePaymentMethodClick = () => {
  //   openModal('payment-method');
  // };

  // Build card display text
  // let cardDisplay: string;
  // if (cardLoading) {
  //   cardDisplay = 'Loading...';
  // } else if (cardError) {
  //   cardDisplay = 'Failed to load payment method';
  // } else if (cardInfo) {
  //   const brand = formatBrand(cardInfo.brand);
  //   const last4 = cardInfo.last4 || '····';
  //   const expMonth =
  //     cardInfo.exp_month != null ? String(cardInfo.exp_month).padStart(2, '0') : '??';
  //   const expYear = cardInfo.exp_year ?? '????';
  //   cardDisplay = `${brand} **** ${last4}  (${expMonth}/${expYear})`;
  // } else if (hasStripeCustomer && planState !== 'trial') {
  //   cardDisplay = 'Payment method on file';
  // } else {
  //   cardDisplay = 'No payment method on file';
  // }

  // const hasPaymentMethod = !!cardInfo || (hasStripeCustomer && planState !== 'trial');

  return (
    <>
      <Panel>
        <Title>Payment method</Title>
        <VSpace $h={16} />

        {/* <MetaRow>
          {cardError ? (
            <Title style={{ fontSize: '13px', fontWeight: '400', color: '#d65f46' }}>
              {cardDisplay}
            </Title>
          ) : hasPaymentMethod ? (
            <Title style={{ fontSize: '13px' }}>{cardDisplay}</Title>
          ) : (
            <Title style={{ fontSize: '13px', fontWeight: '400', color: '#B7BDCB' }}>
              {cardDisplay}
            </Title>
          )}
          {cardError ? (
            <ActionText
              style={{ fontSize: '14px' }}
              onClick={() => {
                setCardError(false);
                setCardLoading(true);
                paymentsApi
                  .getPaymentMethods()
                  .then(({ payment_methods }) =>
                    setCardInfo(payment_methods.length > 0 ? payment_methods[0] : null)
                  )
                  .catch(() => {
                    setCardInfo(null);
                    setCardError(true);
                  })
                  .finally(() => setCardLoading(false));
              }}
            >
              Retry
            </ActionText>
          ) : hasStripeCustomer ? (
            <ActionText style={{ fontSize: '14px' }} onClick={handlePaymentMethodClick}>
              {hasPaymentMethod ? 'Manage' : 'Add card'}
            </ActionText>
          ) : null}
        </MetaRow> */}

        <VSpace $h={12} />
        <Divider />
        <VSpace $h={12} />

        <MetaRow>
          <Title style={{ fontSize: '13px' }}>{displayEmail}</Title>
          <ActionText style={{ fontSize: '14px' }} onClick={handleOpenChangeEmail}>
            Change email
          </ActionText>
        </MetaRow>

        {emailSaveError && (
          <>
            <VSpace $h={8} />
            <Title style={{ fontSize: '12px', color: '#d65f46' }}>{emailSaveError}</Title>
          </>
        )}
      </Panel>

      <ChangeEmailModal
        open={changeEmailOpen}
        initialEmail={displayEmail}
        onClose={handleCloseChangeEmail}
        onSave={handleSaveChangeEmail}
      />
    </>
  );
}
